module.exports = __webpack_public_path__ + "img/groupResultctx.4e35cdd8.png";